export function allSettled<T>(promises: Promise<T>[]) {
    return Promise.all(promises.map(promise => promise
        .then(value => ({ status: 'fulfilled', value } as const))
        .catch(value => ({ status: 'rejected', value } as const)),
    ));
}
